/* eslint-disable */
// This file is auto generated, do not edit!

import type * as Types from 'types/api/dato.types';

import { StructuredTextDocument, TitleMetaLinkTag } from 'react-datocms'
import { TicketsIntegrationField, TicketsPushAppField, IconField } from './dato-extensions.types'
import type { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
import gql from 'graphql-tag';
type ImageFile_AltFileField_Fragment = { id: string, mimeType: string, url: string, alt: string, title: string | undefined, blurUpThumb: string | undefined };

type ImageFile_FileField_Fragment = { id: string, mimeType: string, url: string, alt: string | undefined, title: string | undefined, blurUpThumb: string | undefined };

type ImageFile_ImageFileField_Fragment = { id: string, mimeType: string, url: string, alt: string | undefined, title: string | undefined, blurUpThumb: string | undefined };

export type ImageFileFragment = ImageFile_AltFileField_Fragment | ImageFile_FileField_Fragment | ImageFile_ImageFileField_Fragment;

type VideoUploadFile_AltFileField_Fragment = { id: string, mimeType: string, video: { thumbnailUrl: string, streamingUrl: string } | undefined };

type VideoUploadFile_FileField_Fragment = { id: string, mimeType: string, video: { thumbnailUrl: string, streamingUrl: string } | undefined };

type VideoUploadFile_ImageFileField_Fragment = { id: string, mimeType: string, video: { thumbnailUrl: string, streamingUrl: string } | undefined };

export type VideoUploadFileFragment = VideoUploadFile_AltFileField_Fragment | VideoUploadFile_FileField_Fragment | VideoUploadFile_ImageFileField_Fragment;

type FileField_AltFileField_Fragment = (
  ImageFile_AltFileField_Fragment
  & VideoUploadFile_AltFileField_Fragment
);

type FileField_FileField_Fragment = (
  ImageFile_FileField_Fragment
  & VideoUploadFile_FileField_Fragment
);

type FileField_ImageFileField_Fragment = (
  ImageFile_ImageFileField_Fragment
  & VideoUploadFile_ImageFileField_Fragment
);

export type FileFieldFragment = FileField_AltFileField_Fragment | FileField_FileField_Fragment | FileField_ImageFileField_Fragment;

export type CityCardFragment = { id: string, name: string, slug: string, cover: ImageFile_FileField_Fragment };

export type CollectionFragment = { id: string, slug: string, title: string, timeFilter: string | undefined, venue: { id: string } | undefined, references: { count: number } };

export type ColorAccentFragment = { hex: string };

type CtaPageField_PageCityRecord_Fragment = { slug: string, entity: 'PageCityRecord' };

type CtaPageField_PageEventRecord_Fragment = { slug: string, entity: 'PageEventRecord' };

type CtaPageField_PageHomeRecord_Fragment = { entity: 'PageHomeRecord' };

export type CtaPageFieldFragment = CtaPageField_PageCityRecord_Fragment | CtaPageField_PageEventRecord_Fragment | CtaPageField_PageHomeRecord_Fragment;

export type CtaFragment = { id: string, title: string, isExternal: boolean, url: string | undefined, icon: IconField | undefined, page: Array<CtaPageField_PageCityRecord_Fragment | CtaPageField_PageEventRecord_Fragment | CtaPageField_PageHomeRecord_Fragment> };

export type EventCardFragment = { __typename: 'PageEventRecord', id: string, slug: string, title: string, startDatetime: string | undefined, endDatetime: string | undefined, timezone: string, mdlbeastLineupPath: string | undefined, performersCount: number | undefined, ticketsEventId: string | undefined, ticketsTimeslotId: string | undefined, cover: ImageFile_FileField_Fragment, programs: Array<XpProgramFragment>, venue: { city: { name: string } } };

export type PageEventFragment = { id: string, title: string, slug: string, startDatetime: string | undefined, endDatetime: string | undefined, timezone: string, mdlbeastLineupPath: string | undefined, performersCount: number | undefined, ticketsIntegration: TicketsIntegrationField, ticketsEventId: string | undefined, ticketsExternalUrl: string | undefined, ticketsTimeslotId: string | undefined, ticketsPushApp: TicketsPushAppField, unlistedEvent: boolean, ticketStatusNotice: string | undefined, ticketStatusNoticeSubtitle: string | undefined, yandexUrl: string | undefined, description: { value: StructuredTextDocument } | undefined, cover: ImageFile_FileField_Fragment, performers: Array<PerformerFragment>, programs: Array<XpProgramFragment>, venue: VenueFragment, ticketsStatus: Array<TicketStatusFragment>, linkedPages: Array<PageCardFragment> };

export type FeaturedItemFragment = { id: string, featuredType: string, coverImage: ImageFile_FileField_Fragment, event: (
    { unlistedEvent: boolean }
    & EventCardFragment
  ) | undefined, collection: CollectionFragment | undefined, page: PageCardFragment | undefined };

export type PageFragment = { __typename: 'PageRecord', id: string, title: string, slug: string, cover: ImageFile_FileField_Fragment, sections: Array<CardsSectionFragment | ContentBlockFragment | CountdownFragment | FaqFragment | FeaturedItemsBlockFragment | HeroBannerSectionFragment | IframeBlockFragment | LineupSectionFragment | MediaBlockFragment | SectionFragment | SplitImageContentBlockFragment>, seo: { title: string | undefined, description: string | undefined, image: ImageFile_FileField_Fragment | undefined } | undefined };

export type PageCardFragment = { __typename: 'PageRecord', id: string, title: string, slug: string, cover: ImageFile_FileField_Fragment, seo: { title: string | undefined, description: string | undefined, image: ImageFile_FileField_Fragment | undefined } | undefined };

export type ContentBlockFragment = { __typename: 'ContentBlockRecord', id: string, contentBlockContent: { value: unknown } | undefined };

export type MediaBlockFragment = { __typename: 'MediaBlockRecord', id: string, background: ImageFile_AltFileField_Fragment };

export type FaqItemFragment = { __typename: 'FaqItemRecord', id: string, title: { value: unknown }, description: { value: unknown } };

export type FaqGroupFragment = { __typename: 'FaqGroupRecord', id: string, title: { value: unknown } | undefined, faqItems: Array<FaqItemFragment> };

export type FaqFragment = { __typename: 'FaqRecord', id: string, title: { value: unknown } | undefined, faqGroups: Array<FaqGroupFragment> };

export type CountdownFragment = { __typename: 'CountdownRecord', id: string, endDateTime: string, title: { value: unknown } | undefined, subtitle: { value: unknown } | undefined };

export type SplitImageContentBlockFragment = { __typename: 'SplitImageContentBlockRecord', id: string, reversed: boolean, image: ImageFile_FileField_Fragment, title: { value: unknown } | undefined, description: { value: unknown } | undefined, cta: CtaFragment | undefined };

export type SectionFragment = { __typename: 'SectionRecord', id: string, title: { value: unknown } | undefined, sectionContent: Array<ContentBlockFragment | MediaBlockFragment | SplitImageContentBlockFragment> };

export type HeroBannerSectionFragment = { __typename: 'HeroBannerSectionRecord', id: string, title: { value: unknown } | undefined, subtitle: { value: unknown } | undefined, background: FileField_FileField_Fragment, overlay: ImageFile_FileField_Fragment | undefined, cta: CtaFragment | undefined };

export type LineupSectionItemFragment = { __typename: 'LineupSectionItemRecord', id: string, name: string | undefined, performer: PerformerFragment | undefined, coverImage: ImageFile_ImageFileField_Fragment };

export type LineupSectionFragment = { __typename: 'LineupSectionRecord', id: string, title: { value: unknown } | undefined, cta: CtaFragment | undefined, lineupItems: Array<LineupSectionItemFragment> };

export type TicketCardFragment = { __typename: 'TicketCardRecord', id: string, title: { value: unknown } | undefined, description: { value: unknown } | undefined, cta: CtaFragment | undefined, media: ImageFile_FileField_Fragment | undefined };

export type CardsSectionFragment = { __typename: 'CardsSectionRecord', id: string, title: { value: unknown } | undefined, cards: Array<TicketCardFragment> };

export type IframeBlockFragment = { __typename: 'IframeBlockRecord', id: string, url: string, height: number, fullWidth: boolean };

export type FeaturedItemsBlockFragment = { __typename: 'FeaturedItemsBlockRecord', id: string, items: Array<FeaturedItemFragment> };

export type PerformerFragment = { id: string, name: string, soundcloud: string | undefined, spotify: string | undefined, mixcloud: string | undefined, anghami: string | undefined, youtube: string | undefined, background: ImageFile_FileField_Fragment | undefined };

export type PerformerLinksFragment = { soundcloud: string | undefined, spotify: string | undefined, mixcloud: string | undefined, anghami: string | undefined, youtube: string | undefined };

export type SeoFragment = { attributes: TitleMetaLinkTag['attributes'] | undefined, content: string | undefined, tag: string };

export type TicketStatusFragment = { id: string, statusType: string | undefined, schedule: string | undefined, content: string | undefined, ticketId: string, color: { hex: string } | undefined };

export type VenueFragment = { id: string, name: string, directionsUrl: string | undefined, streetAddress: string | undefined, addressLocality: string | undefined, addressRegion: string | undefined, postalCode: string | undefined, addressCountry: string | undefined, city: { name: string, slug: string }, media: FileField_FileField_Fragment };

export type XpProgramFragment = { id: string, name: string, xpProgramPath: string, background: ImageFile_FileField_Fragment };

export type AffiliateByTicketingIdQueryVariables = Types.Exact<{
  locale: Types.SiteLocale;
  ticketingPlatformSlug?: Types.InputMaybe<Types.Scalars['String']['input']>;
}>;


export type AffiliateByTicketingIdQuery = { affiliatePartner: { id: string, name: string, redirectUrl: string | undefined, ticketingPlatformSlug: string, headingLogo: { url: string } | undefined } | undefined };

export type AllAffiliatesQueryVariables = Types.Exact<{
  locale: Types.SiteLocale;
}>;


export type AllAffiliatesQuery = { allAffiliatePartners: Array<{ name: string, redirectUrl: string | undefined, ticketingPlatformSlug: string, headingLogo: ImageFile_FileField_Fragment | undefined }> };

export type AllPageCitySlugsQueryVariables = Types.Exact<{
  locale: Types.SiteLocale;
}>;


export type AllPageCitySlugsQuery = { allPageCities: Array<{ slug: string }> };

export type CityEventsQueryVariables = Types.Exact<{
  locale: Types.SiteLocale;
  slug: Types.Scalars['String']['input'];
  first?: Types.InputMaybe<Types.Scalars['IntType']['input']>;
  skip?: Types.InputMaybe<Types.Scalars['IntType']['input']>;
  currentISOString: Types.Scalars['DateTime']['input'];
  orderBy?: Types.InputMaybe<Types.PageEventModelOrderBy>;
}>;


export type CityEventsQuery = { pageCity: { venues: Array<{ events: Array<EventCardFragment>, meta: { count: number } }> } | undefined };

export type PageCityFragment = { id: string, slug: string, name: string, cover: ImageFile_FileField_Fragment };

export type PageCityQueryVariables = Types.Exact<{
  locale: Types.SiteLocale;
  slug: Types.Scalars['String']['input'];
}>;


export type PageCityQuery = { pageCity: (
    { seoTags: Array<SeoFragment> }
    & PageCityFragment
  ) | undefined };

export type AllPageCollectionSlugsQueryVariables = Types.Exact<{
  locale: Types.SiteLocale;
}>;


export type AllPageCollectionSlugsQuery = { allPageCollections: Array<{ slug: string }> };

export type PageCollectionFragment = { id: string, title: string, slug: string, timeFilter: string | undefined, description: { value: StructuredTextDocument } | undefined, cover: ImageFile_FileField_Fragment | undefined, venue: { id: string } | undefined };

export type PageCollectionQueryVariables = Types.Exact<{
  locale: Types.SiteLocale;
  slug: Types.Scalars['String']['input'];
}>;


export type PageCollectionQuery = { pageCollection: (
    { seoTags: Array<SeoFragment> }
    & PageCollectionFragment
  ) | undefined };

export type ConfigQueryVariables = Types.Exact<{
  locale: Types.SiteLocale;
}>;


export type ConfigQuery = { appConfig: { minimalAppVersion: string, harassmentUrl: string | undefined, lostFoundUrl: string | undefined } | undefined };

export type PageECommerceFragment = { id: string };

export type PageECommerceQueryVariables = Types.Exact<{
  locale: Types.SiteLocale;
}>;


export type PageECommerceQuery = { pageECommerce: (
    { seoTags: Array<SeoFragment> }
    & PageECommerceFragment
  ) | undefined };

export type AllPageEventSlugsQueryVariables = Types.Exact<{
  locale: Types.SiteLocale;
  first?: Types.InputMaybe<Types.Scalars['IntType']['input']>;
  filter?: Types.InputMaybe<Types.PageEventModelFilter>;
}>;


export type AllPageEventSlugsQuery = { allPageEvents: Array<{ slug: string }>, meta: { count: number } };

export type MoreEventsQueryVariables = Types.Exact<{
  locale: Types.SiteLocale;
  slug: Types.Scalars['String']['input'];
  filter?: Types.InputMaybe<Types.PageEventModelFilter>;
  orderBy?: Types.InputMaybe<Types.PageEventModelOrderBy>;
}>;


export type MoreEventsQuery = { pageEvent: { moreEvents: { city: { venues: Array<{ events: Array<EventCardFragment> }> } } } | undefined };

export type PageEventQueryVariables = Types.Exact<{
  locale: Types.SiteLocale;
  filter?: Types.InputMaybe<Types.PageEventModelFilter>;
}>;


export type PageEventQuery = { pageEvent: (
    { seoTags: Array<SeoFragment> }
    & PageEventFragment
  ) | undefined };

export type PageEventsQueryVariables = Types.Exact<{
  locale: Types.SiteLocale;
  orderBy?: Types.InputMaybe<Types.PageEventModelOrderBy>;
  filter?: Types.InputMaybe<Types.PageEventModelFilter>;
  first?: Types.InputMaybe<Types.Scalars['IntType']['input']>;
  skip?: Types.InputMaybe<Types.Scalars['IntType']['input']>;
}>;


export type PageEventsQuery = { allPageEvents: Array<PageEventFragment>, meta: { count: number } };

export type PageEventsCardsQueryVariables = Types.Exact<{
  locale: Types.SiteLocale;
  orderBy?: Types.InputMaybe<Types.PageEventModelOrderBy>;
  filter?: Types.InputMaybe<Types.PageEventModelFilter>;
  first?: Types.InputMaybe<Types.Scalars['IntType']['input']>;
  skip?: Types.InputMaybe<Types.Scalars['IntType']['input']>;
}>;


export type PageEventsCardsQuery = { allPageEvents: Array<EventCardFragment>, meta: { count: number } };

export type UnlistedEventsQueryVariables = Types.Exact<{
  first?: Types.InputMaybe<Types.Scalars['IntType']['input']>;
  skip?: Types.InputMaybe<Types.Scalars['IntType']['input']>;
}>;


export type UnlistedEventsQuery = { events: Array<{ slug: string }>, meta: { count: number } };

export type FooterLinkFragment = { id: string, label: string, url: string };

export type StoreLinksFragment = { appleStoreUrl: string | undefined, googlePlayUrl: string | undefined };

export type SocialLinksFragment = { instagram: string | undefined, twitter: string | undefined, linkedin: string | undefined, facebook: string | undefined, snapchat: string | undefined };

export type FooterQueryVariables = Types.Exact<{
  locale: Types.SiteLocale;
}>;


export type FooterQuery = { footer: (
    { footerLinks: Array<FooterLinkFragment> }
    & StoreLinksFragment
    & SocialLinksFragment
  ) | undefined };

export type PageLoyaltyInformationFragment = { id: string, title: string, updatedAt: string, body: { value: StructuredTextDocument } };

export type LoyaltyInformationQueryVariables = Types.Exact<{
  locale: Types.SiteLocale;
}>;


export type LoyaltyInformationQuery = { pageLoyaltyInformation: (
    { seoTags: Array<SeoFragment> }
    & PageLoyaltyInformationFragment
  ) | undefined };

export type PagePrivacyPolicyFragment = { id: string, title: string, updatedAt: string, body: { value: StructuredTextDocument } };

export type PrivacyPolicyQueryVariables = Types.Exact<{
  locale: Types.SiteLocale;
}>;


export type PrivacyPolicyQuery = { pagePrivacyPolicy: (
    { seoTags: Array<SeoFragment> }
    & PagePrivacyPolicyFragment
  ) | undefined };

export type SeoTitleSuffixQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type SeoTitleSuffixQuery = { _site: { globalSeo: { titleSuffix: string | undefined } | undefined } };

export type PageTermsOfServiceFragment = { id: string, title: string, updatedAt: string, body: { value: StructuredTextDocument } };

export type TermsOfServiceQueryVariables = Types.Exact<{
  locale: Types.SiteLocale;
}>;


export type TermsOfServiceQuery = { pageTermsOfService: (
    { seoTags: Array<SeoFragment> }
    & PageTermsOfServiceFragment
  ) | undefined };

export type TranslationsQueryVariables = Types.Exact<{
  locale: Types.SiteLocale;
  first?: Types.InputMaybe<Types.Scalars['IntType']['input']>;
  skip?: Types.InputMaybe<Types.Scalars['IntType']['input']>;
}>;


export type TranslationsQuery = { translations: Array<{ label: string, value: string }>, meta: { count: number } };

export type PageHomeFragment = { id: string, featuredItems: Array<FeaturedItemFragment>, collections: Array<CollectionFragment>, cities: Array<(
    { venues: Array<{ eventMeta: { count: number } }> }
    & CityCardFragment
  )> };

export type PageHomeQueryVariables = Types.Exact<{
  locale: Types.SiteLocale;
  currentISOString?: Types.InputMaybe<Types.Scalars['DateTime']['input']>;
}>;


export type PageHomeQuery = { pageHome: (
    { seoTags: Array<SeoFragment> }
    & PageHomeFragment
  ) | undefined };

export type SitemapQueryVariables = Types.Exact<{
  locale: Types.SiteLocale;
  endDatetime: Types.Scalars['DateTime']['input'];
}>;


export type SitemapQuery = { events: Array<{ __typename: 'PageEventRecord', slug: string, ticketsIntegration: TicketsIntegrationField, ticketsEventId: string | undefined, updatedAt: string, seo: { noIndex: boolean | undefined } | undefined }>, collections: Array<{ __typename: 'PageCollectionRecord', slug: string, updatedAt: string, seo: { noIndex: boolean | undefined } | undefined }>, cities: Array<{ __typename: 'PageCityRecord', slug: string, updatedAt: string, seo: { noIndex: boolean | undefined } | undefined }> };

export type PageLoyaltyTermsOfConditionFragment = { id: string, title: string, updatedAt: string, body: { value: StructuredTextDocument } };

export type LoyaltyTermsOfConditionQueryVariables = Types.Exact<{
  locale: Types.SiteLocale;
}>;


export type LoyaltyTermsOfConditionQuery = { pageLoyaltyTermsOfCondition: (
    { seoTags: Array<SeoFragment> }
    & PageLoyaltyTermsOfConditionFragment
  ) | undefined };

export type TicketOfferQueryVariables = Types.Exact<{
  locale: Types.SiteLocale;
  eventId: Types.Scalars['ItemId']['input'];
  code: Types.Scalars['String']['input'];
}>;


export type TicketOfferQuery = { ticketOffer: { id: string, customerLoyaltyId: string | undefined, available: boolean, code: string, event: { slug: string }, categories: Array<{ title: string, ticketIds: string }> } | undefined };

export type AllPageSlugsQueryVariables = Types.Exact<{
  locale: Types.SiteLocale;
}>;


export type AllPageSlugsQuery = { allPages: Array<{ slug: string, title: string, cover: ImageFile_FileField_Fragment }> };

export type PageQueryVariables = Types.Exact<{
  locale: Types.SiteLocale;
  filter?: Types.InputMaybe<Types.PageModelFilter>;
  currentISOString?: Types.InputMaybe<Types.Scalars['DateTime']['input']>;
}>;


export type PageQuery = { page: (
    { seoTags: Array<SeoFragment> }
    & PageFragment
  ) | undefined };

export type TicketsEventIdByDatoEventSlugQueryVariables = Types.Exact<{
  locale: Types.SiteLocale;
  slug: Types.Scalars['String']['input'];
}>;


export type TicketsEventIdByDatoEventSlugQuery = { pageEvent: { ticketsEventId: string | undefined, ticketsTimeslotId: string | undefined } | undefined };

export const ColorAccentFragmentDoc = gql`
    fragment ColorAccent on ColorField {
  hex
}
    ` as unknown as DocumentNode<ColorAccentFragment, unknown>;
export const ImageFileFragmentDoc = gql`
    fragment ImageFile on FileFieldInterface {
  id
  mimeType
  url
  alt
  title
  blurUpThumb
}
    ` as unknown as DocumentNode<ImageFileFragment, unknown>;
export const PerformerFragmentDoc = gql`
    fragment Performer on PerformerRecord {
  id
  name
  background {
    ...ImageFile
  }
  soundcloud
  spotify
  mixcloud
  anghami
  youtube
}
    ` as unknown as DocumentNode<PerformerFragment, unknown>;
export const XpProgramFragmentDoc = gql`
    fragment XpProgram on XpProgramRecord {
  id
  name
  background {
    ...ImageFile
  }
  xpProgramPath
}
    ` as unknown as DocumentNode<XpProgramFragment, unknown>;
export const VideoUploadFileFragmentDoc = gql`
    fragment VideoUploadFile on FileFieldInterface {
  id
  mimeType
  video {
    thumbnailUrl
    streamingUrl
  }
}
    ` as unknown as DocumentNode<VideoUploadFileFragment, unknown>;
export const FileFieldFragmentDoc = gql`
    fragment FileField on FileFieldInterface {
  ...ImageFile
  ...VideoUploadFile
}
    ` as unknown as DocumentNode<FileFieldFragment, unknown>;
export const VenueFragmentDoc = gql`
    fragment Venue on VenueRecord {
  id
  name
  city {
    name
    slug
  }
  media {
    ...FileField
  }
  directionsUrl
  streetAddress(fallbackLocales: en)
  addressLocality(fallbackLocales: en)
  addressRegion(fallbackLocales: en)
  postalCode(fallbackLocales: en)
  addressCountry(fallbackLocales: en)
}
    ` as unknown as DocumentNode<VenueFragment, unknown>;
export const TicketStatusFragmentDoc = gql`
    fragment TicketStatus on TicketStatusRecord {
  id
  statusType
  schedule
  content
  ticketId
  color {
    hex
  }
}
    ` as unknown as DocumentNode<TicketStatusFragment, unknown>;
export const PageCardFragmentDoc = gql`
    fragment PageCard on PageRecord {
  __typename
  id
  title
  slug
  cover {
    ...ImageFile
  }
  seo {
    title
    description
    image {
      ...ImageFile
    }
  }
}
    ` as unknown as DocumentNode<PageCardFragment, unknown>;
export const PageEventFragmentDoc = gql`
    fragment PageEvent on PageEventRecord {
  id
  title
  slug
  description {
    value
  }
  cover {
    ...ImageFile
  }
  startDatetime
  endDatetime
  timezone
  performers {
    ...Performer
  }
  mdlbeastLineupPath
  performersCount
  programs {
    ...XpProgram
  }
  venue {
    ...Venue
  }
  ticketsIntegration
  ticketsEventId
  ticketsExternalUrl
  ticketsTimeslotId
  ticketsPushApp
  unlistedEvent
  ticketStatusNotice
  ticketStatusNoticeSubtitle
  ticketsStatus {
    ...TicketStatus
  }
  linkedPages {
    ...PageCard
  }
  yandexUrl
}
    ` as unknown as DocumentNode<PageEventFragment, unknown>;
export const ContentBlockFragmentDoc = gql`
    fragment ContentBlock on ContentBlockRecord {
  __typename
  id
  contentBlockContent: content {
    value
  }
}
    ` as unknown as DocumentNode<ContentBlockFragment, unknown>;
export const MediaBlockFragmentDoc = gql`
    fragment MediaBlock on MediaBlockRecord {
  __typename
  id
  background {
    ...ImageFile
  }
}
    ` as unknown as DocumentNode<MediaBlockFragment, unknown>;
export const FaqItemFragmentDoc = gql`
    fragment FaqItem on FaqItemRecord {
  __typename
  id
  title {
    value
  }
  description {
    value
  }
}
    ` as unknown as DocumentNode<FaqItemFragment, unknown>;
export const FaqGroupFragmentDoc = gql`
    fragment FaqGroup on FaqGroupRecord {
  __typename
  id
  title {
    value
  }
  faqItems {
    ... on FaqItemRecord {
      ...FaqItem
    }
  }
}
    ` as unknown as DocumentNode<FaqGroupFragment, unknown>;
export const FaqFragmentDoc = gql`
    fragment Faq on FaqRecord {
  __typename
  id
  title {
    value
  }
  faqGroups {
    ... on FaqGroupRecord {
      ...FaqGroup
    }
  }
}
    ` as unknown as DocumentNode<FaqFragment, unknown>;
export const CountdownFragmentDoc = gql`
    fragment Countdown on CountdownRecord {
  __typename
  id
  title {
    value
  }
  subtitle {
    value
  }
  endDateTime
}
    ` as unknown as DocumentNode<CountdownFragment, unknown>;
export const CtaPageFieldFragmentDoc = gql`
    fragment CtaPageField on CtaModelPageField {
  entity: __typename
  ... on PageCityRecord {
    slug
  }
  ... on PageEventRecord {
    slug
  }
}
    ` as unknown as DocumentNode<CtaPageFieldFragment, unknown>;
export const CtaFragmentDoc = gql`
    fragment Cta on CtaRecord {
  id
  title
  isExternal
  url
  page {
    ...CtaPageField
  }
  icon
}
    ` as unknown as DocumentNode<CtaFragment, unknown>;
export const SplitImageContentBlockFragmentDoc = gql`
    fragment SplitImageContentBlock on SplitImageContentBlockRecord {
  __typename
  id
  image {
    ...ImageFile
  }
  title {
    value
  }
  description {
    value
  }
  cta {
    ...Cta
  }
  reversed
}
    ` as unknown as DocumentNode<SplitImageContentBlockFragment, unknown>;
export const SectionFragmentDoc = gql`
    fragment Section on SectionRecord {
  __typename
  id
  title {
    value
  }
  sectionContent: content {
    ... on ContentBlockRecord {
      ...ContentBlock
    }
    ... on SplitImageContentBlockRecord {
      ...SplitImageContentBlock
    }
    ... on MediaBlockRecord {
      ...MediaBlock
    }
  }
}
    ` as unknown as DocumentNode<SectionFragment, unknown>;
export const HeroBannerSectionFragmentDoc = gql`
    fragment HeroBannerSection on HeroBannerSectionRecord {
  __typename
  id
  title {
    value
  }
  subtitle {
    value
  }
  background {
    ...FileField
  }
  overlay {
    ...ImageFile
  }
  cta {
    ...Cta
  }
}
    ` as unknown as DocumentNode<HeroBannerSectionFragment, unknown>;
export const LineupSectionItemFragmentDoc = gql`
    fragment LineupSectionItem on LineupSectionItemRecord {
  __typename
  id
  name
  performer {
    ...Performer
  }
  coverImage {
    ...ImageFile
  }
}
    ` as unknown as DocumentNode<LineupSectionItemFragment, unknown>;
export const LineupSectionFragmentDoc = gql`
    fragment LineupSection on LineupSectionRecord {
  __typename
  id
  title {
    value
  }
  cta {
    ...Cta
  }
  lineupItems {
    ... on LineupSectionItemRecord {
      ...LineupSectionItem
    }
  }
}
    ` as unknown as DocumentNode<LineupSectionFragment, unknown>;
export const TicketCardFragmentDoc = gql`
    fragment TicketCard on TicketCardRecord {
  __typename
  id
  title {
    value
  }
  description {
    value
  }
  cta {
    ...Cta
  }
  media {
    ...ImageFile
  }
}
    ` as unknown as DocumentNode<TicketCardFragment, unknown>;
export const CardsSectionFragmentDoc = gql`
    fragment CardsSection on CardsSectionRecord {
  __typename
  id
  title {
    value
  }
  cards {
    ... on TicketCardRecord {
      ...TicketCard
    }
  }
}
    ` as unknown as DocumentNode<CardsSectionFragment, unknown>;
export const IframeBlockFragmentDoc = gql`
    fragment IframeBlock on IframeBlockRecord {
  __typename
  id
  url
  height
  fullWidth
}
    ` as unknown as DocumentNode<IframeBlockFragment, unknown>;
export const EventCardFragmentDoc = gql`
    fragment EventCard on PageEventRecord {
  __typename
  id
  slug
  title
  cover {
    ...ImageFile
  }
  startDatetime
  endDatetime
  timezone
  mdlbeastLineupPath
  performersCount
  programs {
    ...XpProgram
  }
  venue {
    city {
      name
    }
  }
  ticketsEventId
  ticketsTimeslotId
}
    ` as unknown as DocumentNode<EventCardFragment, unknown>;
export const CollectionFragmentDoc = gql`
    fragment Collection on PageCollectionRecord {
  id
  slug
  title
  timeFilter
  venue {
    id
  }
  references: _allReferencingPageEventsMeta(
    filter: {endDatetime: {gte: $currentISOString}, unlistedEvent: {eq: false}}
  ) {
    count
  }
}
    ` as unknown as DocumentNode<CollectionFragment, unknown>;
export const FeaturedItemFragmentDoc = gql`
    fragment FeaturedItem on FeaturedItemBlockRecord {
  id
  featuredType
  coverImage {
    ...ImageFile
  }
  event {
    ...EventCard
    unlistedEvent
  }
  collection {
    ...Collection
  }
  page {
    ...PageCard
  }
}
    ` as unknown as DocumentNode<FeaturedItemFragment, unknown>;
export const FeaturedItemsBlockFragmentDoc = gql`
    fragment FeaturedItemsBlock on FeaturedItemsBlockRecord {
  __typename
  id
  items {
    ...FeaturedItem
  }
}
    ` as unknown as DocumentNode<FeaturedItemsBlockFragment, unknown>;
export const PageFragmentDoc = gql`
    fragment Page on PageRecord {
  __typename
  id
  title
  slug
  cover {
    ...ImageFile
  }
  sections {
    ... on ContentBlockRecord {
      ...ContentBlock
    }
    ... on MediaBlockRecord {
      ...MediaBlock
    }
    ... on FaqRecord {
      ...Faq
    }
    ... on CountdownRecord {
      ...Countdown
    }
    ... on SplitImageContentBlockRecord {
      ...SplitImageContentBlock
    }
    ... on SectionRecord {
      ...Section
    }
    ... on HeroBannerSectionRecord {
      ...HeroBannerSection
    }
    ... on LineupSectionRecord {
      ...LineupSection
    }
    ... on CardsSectionRecord {
      ...CardsSection
    }
    ... on IframeBlockRecord {
      ...IframeBlock
    }
    ... on FeaturedItemsBlockRecord {
      ...FeaturedItemsBlock
    }
  }
  seo {
    title
    description
    image {
      ...ImageFile
    }
  }
}
    ` as unknown as DocumentNode<PageFragment, unknown>;
export const PerformerLinksFragmentDoc = gql`
    fragment PerformerLinks on PerformerRecord {
  soundcloud
  spotify
  mixcloud
  anghami
  youtube
}
    ` as unknown as DocumentNode<PerformerLinksFragment, unknown>;
export const SeoFragmentDoc = gql`
    fragment Seo on Tag {
  attributes
  content
  tag
}
    ` as unknown as DocumentNode<SeoFragment, unknown>;
export const PageCityFragmentDoc = gql`
    fragment PageCity on PageCityRecord {
  id
  slug
  name
  cover {
    ...ImageFile
  }
}
    ` as unknown as DocumentNode<PageCityFragment, unknown>;
export const PageCollectionFragmentDoc = gql`
    fragment PageCollection on PageCollectionRecord {
  id
  title
  slug
  description {
    value
  }
  cover {
    ...ImageFile
  }
  timeFilter
  venue {
    id
  }
}
    ` as unknown as DocumentNode<PageCollectionFragment, unknown>;
export const PageECommerceFragmentDoc = gql`
    fragment PageECommerce on PageECommerceRecord {
  id
}
    ` as unknown as DocumentNode<PageECommerceFragment, unknown>;
export const FooterLinkFragmentDoc = gql`
    fragment FooterLink on FooterLinkRecord {
  id
  label
  url
}
    ` as unknown as DocumentNode<FooterLinkFragment, unknown>;
export const StoreLinksFragmentDoc = gql`
    fragment StoreLinks on FooterRecord {
  appleStoreUrl
  googlePlayUrl
}
    ` as unknown as DocumentNode<StoreLinksFragment, unknown>;
export const SocialLinksFragmentDoc = gql`
    fragment SocialLinks on FooterRecord {
  instagram
  twitter
  linkedin
  facebook
  snapchat
}
    ` as unknown as DocumentNode<SocialLinksFragment, unknown>;
export const PageLoyaltyInformationFragmentDoc = gql`
    fragment PageLoyaltyInformation on PageLoyaltyInformationRecord {
  id
  title
  body {
    value
  }
  updatedAt: _updatedAt
}
    ` as unknown as DocumentNode<PageLoyaltyInformationFragment, unknown>;
export const PagePrivacyPolicyFragmentDoc = gql`
    fragment PagePrivacyPolicy on PagePrivacyPolicyRecord {
  id
  title
  body {
    value
  }
  updatedAt: _updatedAt
}
    ` as unknown as DocumentNode<PagePrivacyPolicyFragment, unknown>;
export const PageTermsOfServiceFragmentDoc = gql`
    fragment PageTermsOfService on PageTermsOfServiceRecord {
  id
  title
  body {
    value
  }
  updatedAt: _updatedAt
}
    ` as unknown as DocumentNode<PageTermsOfServiceFragment, unknown>;
export const CityCardFragmentDoc = gql`
    fragment CityCard on PageCityRecord {
  id
  name
  slug
  cover {
    ...ImageFile
  }
}
    ` as unknown as DocumentNode<CityCardFragment, unknown>;
export const PageHomeFragmentDoc = gql`
    fragment PageHome on PageHomeRecord {
  id
  featuredItems {
    ...FeaturedItem
  }
  collections {
    ...Collection
  }
  cities {
    ...CityCard
    venues: _allReferencingVenues(through: {fields: {anyIn: [venue_city]}}) {
      eventMeta: _allReferencingPageEventsMeta(
        through: {fields: {anyIn: [pageEvent_venue]}}
        filter: {endDatetime: {gte: $currentISOString}, unlistedEvent: {eq: false}}
      ) {
        count
      }
    }
  }
}
    ` as unknown as DocumentNode<PageHomeFragment, unknown>;
export const PageLoyaltyTermsOfConditionFragmentDoc = gql`
    fragment PageLoyaltyTermsOfCondition on PageLoyaltyTermsOfConditionRecord {
  id
  title
  body {
    value
  }
  updatedAt: _updatedAt
}
    ` as unknown as DocumentNode<PageLoyaltyTermsOfConditionFragment, unknown>;
export const AffiliateByTicketingIdDocument = gql`
    query affiliateByTicketingId($locale: SiteLocale!, $ticketingPlatformSlug: String) {
  affiliatePartner(
    locale: $locale
    filter: {ticketingPlatformSlug: {eq: $ticketingPlatformSlug}}
  ) {
    id
    name
    redirectUrl
    ticketingPlatformSlug
    headingLogo {
      url
    }
  }
}
    ` as unknown as DocumentNode<AffiliateByTicketingIdQuery, AffiliateByTicketingIdQueryVariables>;
export const AllAffiliatesDocument = gql`
    query allAffiliates($locale: SiteLocale!) {
  allAffiliatePartners(locale: $locale, orderBy: _updatedAt_DESC) {
    name
    redirectUrl
    ticketingPlatformSlug
    headingLogo {
      ...ImageFile
    }
  }
}
    ${ImageFileFragmentDoc}` as unknown as DocumentNode<AllAffiliatesQuery, AllAffiliatesQueryVariables>;
export const AllPageCitySlugsDocument = gql`
    query allPageCitySlugs($locale: SiteLocale!) {
  allPageCities(locale: $locale, orderBy: _updatedAt_DESC) {
    slug
  }
}
    ` as unknown as DocumentNode<AllPageCitySlugsQuery, AllPageCitySlugsQueryVariables>;
export const CityEventsDocument = gql`
    query cityEvents($locale: SiteLocale!, $slug: String!, $first: IntType, $skip: IntType = 0, $currentISOString: DateTime!, $orderBy: PageEventModelOrderBy) {
  pageCity(locale: $locale, filter: {slug: {eq: $slug}}, fallbackLocales: en) {
    venues: _allReferencingVenues(through: {fields: {anyIn: [venue_city]}}) {
      events: _allReferencingPageEvents(
        through: {fields: {anyIn: [pageEvent_venue]}}
        filter: {endDatetime: {gte: $currentISOString}, unlistedEvent: {eq: false}}
        first: $first
        skip: $skip
        orderBy: [$orderBy]
      ) {
        ...EventCard
      }
      meta: _allReferencingPageEventsMeta(
        through: {fields: {anyIn: [pageEvent_venue]}}
        filter: {endDatetime: {gte: $currentISOString}, unlistedEvent: {eq: false}}
      ) {
        count
      }
    }
  }
}
    ${EventCardFragmentDoc}
${ImageFileFragmentDoc}
${XpProgramFragmentDoc}` as unknown as DocumentNode<CityEventsQuery, CityEventsQueryVariables>;
export const PageCityDocument = gql`
    query pageCity($locale: SiteLocale!, $slug: String!) {
  pageCity(locale: $locale, filter: {slug: {eq: $slug}}) {
    ...PageCity
    seoTags: _seoMetaTags {
      ...Seo
    }
  }
}
    ${PageCityFragmentDoc}
${ImageFileFragmentDoc}
${SeoFragmentDoc}` as unknown as DocumentNode<PageCityQuery, PageCityQueryVariables>;
export const AllPageCollectionSlugsDocument = gql`
    query allPageCollectionSlugs($locale: SiteLocale!) {
  allPageCollections(locale: $locale, orderBy: _firstPublishedAt_DESC) {
    slug
  }
}
    ` as unknown as DocumentNode<AllPageCollectionSlugsQuery, AllPageCollectionSlugsQueryVariables>;
export const PageCollectionDocument = gql`
    query pageCollection($locale: SiteLocale!, $slug: String!) {
  pageCollection(locale: $locale, filter: {slug: {eq: $slug}}) {
    ...PageCollection
    seoTags: _seoMetaTags {
      ...Seo
    }
  }
}
    ${PageCollectionFragmentDoc}
${ImageFileFragmentDoc}
${SeoFragmentDoc}` as unknown as DocumentNode<PageCollectionQuery, PageCollectionQueryVariables>;
export const ConfigDocument = gql`
    query config($locale: SiteLocale!) {
  appConfig(locale: $locale) {
    minimalAppVersion
    harassmentUrl
    lostFoundUrl
  }
}
    ` as unknown as DocumentNode<ConfigQuery, ConfigQueryVariables>;
export const PageECommerceDocument = gql`
    query PageECommerce($locale: SiteLocale!) {
  pageECommerce(locale: $locale) {
    ...PageECommerce
    seoTags: _seoMetaTags {
      ...Seo
    }
  }
}
    ${PageECommerceFragmentDoc}
${SeoFragmentDoc}` as unknown as DocumentNode<PageECommerceQuery, PageECommerceQueryVariables>;
export const AllPageEventSlugsDocument = gql`
    query allPageEventSlugs($locale: SiteLocale!, $first: IntType, $filter: PageEventModelFilter) {
  allPageEvents(
    locale: $locale
    first: $first
    orderBy: _firstPublishedAt_DESC
    filter: $filter
  ) {
    slug
  }
  meta: _allPageEventsMeta {
    count
  }
}
    ` as unknown as DocumentNode<AllPageEventSlugsQuery, AllPageEventSlugsQueryVariables>;
export const MoreEventsDocument = gql`
    query moreEvents($locale: SiteLocale!, $slug: String!, $filter: PageEventModelFilter, $orderBy: PageEventModelOrderBy) {
  pageEvent(
    locale: $locale
    filter: {slug: {eq: $slug}}
    fallbackLocales: en
    orderBy: [$orderBy]
  ) {
    moreEvents: venue {
      city {
        venues: _allReferencingVenues(through: {fields: {anyIn: [venue_city]}}) {
          events: _allReferencingPageEvents(
            through: {fields: {anyIn: [pageEvent_venue]}}
            filter: $filter
            orderBy: endDatetime_ASC
            first: 9
          ) {
            ...EventCard
          }
        }
      }
    }
  }
}
    ${EventCardFragmentDoc}
${ImageFileFragmentDoc}
${XpProgramFragmentDoc}` as unknown as DocumentNode<MoreEventsQuery, MoreEventsQueryVariables>;
export const PageEventDocument = gql`
    query pageEvent($locale: SiteLocale!, $filter: PageEventModelFilter) {
  pageEvent(locale: $locale, filter: $filter, fallbackLocales: en) {
    ...PageEvent
    seoTags: _seoMetaTags {
      ...Seo
    }
  }
}
    ${PageEventFragmentDoc}
${ImageFileFragmentDoc}
${PerformerFragmentDoc}
${XpProgramFragmentDoc}
${VenueFragmentDoc}
${FileFieldFragmentDoc}
${VideoUploadFileFragmentDoc}
${TicketStatusFragmentDoc}
${PageCardFragmentDoc}
${SeoFragmentDoc}` as unknown as DocumentNode<PageEventQuery, PageEventQueryVariables>;
export const PageEventsDocument = gql`
    query pageEvents($locale: SiteLocale!, $orderBy: PageEventModelOrderBy, $filter: PageEventModelFilter, $first: IntType, $skip: IntType = 0) {
  allPageEvents(
    locale: $locale
    orderBy: [$orderBy]
    filter: $filter
    first: $first
    skip: $skip
  ) {
    ...PageEvent
  }
  meta: _allPageEventsMeta(locale: $locale, filter: $filter) {
    count
  }
}
    ${PageEventFragmentDoc}
${ImageFileFragmentDoc}
${PerformerFragmentDoc}
${XpProgramFragmentDoc}
${VenueFragmentDoc}
${FileFieldFragmentDoc}
${VideoUploadFileFragmentDoc}
${TicketStatusFragmentDoc}
${PageCardFragmentDoc}` as unknown as DocumentNode<PageEventsQuery, PageEventsQueryVariables>;
export const PageEventsCardsDocument = gql`
    query pageEventsCards($locale: SiteLocale!, $orderBy: PageEventModelOrderBy, $filter: PageEventModelFilter, $first: IntType, $skip: IntType = 0) {
  allPageEvents(
    locale: $locale
    orderBy: [$orderBy]
    filter: $filter
    first: $first
    skip: $skip
  ) {
    ...EventCard
  }
  meta: _allPageEventsMeta(locale: $locale, filter: $filter) {
    count
  }
}
    ${EventCardFragmentDoc}
${ImageFileFragmentDoc}
${XpProgramFragmentDoc}` as unknown as DocumentNode<PageEventsCardsQuery, PageEventsCardsQueryVariables>;
export const UnlistedEventsDocument = gql`
    query unlistedEvents($first: IntType = 100, $skip: IntType) {
  events: allPageEvents(
    first: $first
    skip: $skip
    filter: {unlistedEvent: {eq: true}}
  ) {
    slug
  }
  meta: _allPageEventsMeta(filter: {unlistedEvent: {eq: true}}) {
    count
  }
}
    ` as unknown as DocumentNode<UnlistedEventsQuery, UnlistedEventsQueryVariables>;
export const FooterDocument = gql`
    query footer($locale: SiteLocale!) {
  footer(locale: $locale) {
    ...StoreLinks
    ...SocialLinks
    footerLinks {
      ...FooterLink
    }
  }
}
    ${StoreLinksFragmentDoc}
${SocialLinksFragmentDoc}
${FooterLinkFragmentDoc}` as unknown as DocumentNode<FooterQuery, FooterQueryVariables>;
export const LoyaltyInformationDocument = gql`
    query loyaltyInformation($locale: SiteLocale!) {
  pageLoyaltyInformation(locale: $locale) {
    ...PageLoyaltyInformation
    seoTags: _seoMetaTags {
      ...Seo
    }
  }
}
    ${PageLoyaltyInformationFragmentDoc}
${SeoFragmentDoc}` as unknown as DocumentNode<LoyaltyInformationQuery, LoyaltyInformationQueryVariables>;
export const PrivacyPolicyDocument = gql`
    query privacyPolicy($locale: SiteLocale!) {
  pagePrivacyPolicy(locale: $locale) {
    ...PagePrivacyPolicy
    seoTags: _seoMetaTags {
      ...Seo
    }
  }
}
    ${PagePrivacyPolicyFragmentDoc}
${SeoFragmentDoc}` as unknown as DocumentNode<PrivacyPolicyQuery, PrivacyPolicyQueryVariables>;
export const SeoTitleSuffixDocument = gql`
    query seoTitleSuffix {
  _site {
    globalSeo {
      titleSuffix
    }
  }
}
    ` as unknown as DocumentNode<SeoTitleSuffixQuery, SeoTitleSuffixQueryVariables>;
export const TermsOfServiceDocument = gql`
    query termsOfService($locale: SiteLocale!) {
  pageTermsOfService(locale: $locale) {
    ...PageTermsOfService
    seoTags: _seoMetaTags {
      ...Seo
    }
  }
}
    ${PageTermsOfServiceFragmentDoc}
${SeoFragmentDoc}` as unknown as DocumentNode<TermsOfServiceQuery, TermsOfServiceQueryVariables>;
export const TranslationsDocument = gql`
    query translations($locale: SiteLocale!, $first: IntType = 100, $skip: IntType = 0) {
  translations: allTranslations(
    locale: $locale
    first: $first
    skip: $skip
    orderBy: label_ASC
  ) {
    label
    value
  }
  meta: _allTranslationsMeta(locale: $locale) {
    count
  }
}
    ` as unknown as DocumentNode<TranslationsQuery, TranslationsQueryVariables>;
export const PageHomeDocument = gql`
    query pageHome($locale: SiteLocale!, $currentISOString: DateTime) {
  pageHome(locale: $locale) {
    ...PageHome
    seoTags: _seoMetaTags {
      ...Seo
    }
  }
}
    ${PageHomeFragmentDoc}
${FeaturedItemFragmentDoc}
${ImageFileFragmentDoc}
${EventCardFragmentDoc}
${XpProgramFragmentDoc}
${CollectionFragmentDoc}
${PageCardFragmentDoc}
${CityCardFragmentDoc}
${SeoFragmentDoc}` as unknown as DocumentNode<PageHomeQuery, PageHomeQueryVariables>;
export const SitemapDocument = gql`
    query sitemap($locale: SiteLocale!, $endDatetime: DateTime!) {
  events: allPageEvents(
    locale: $locale
    filter: {endDatetime: {gte: $endDatetime}}
    orderBy: startDatetime_ASC
    first: 100
  ) {
    __typename
    slug
    updatedAt: _updatedAt
    ticketsIntegration
    ticketsEventId
    seo {
      noIndex
    }
  }
  collections: allPageCollections(
    locale: $locale
    orderBy: _firstPublishedAt_DESC
  ) {
    __typename
    slug
    updatedAt: _updatedAt
    seo {
      noIndex
    }
  }
  cities: allPageCities(locale: $locale, orderBy: _updatedAt_DESC) {
    __typename
    slug
    updatedAt: _updatedAt
    seo {
      noIndex
    }
  }
}
    ` as unknown as DocumentNode<SitemapQuery, SitemapQueryVariables>;
export const LoyaltyTermsOfConditionDocument = gql`
    query loyaltyTermsOfCondition($locale: SiteLocale!) {
  pageLoyaltyTermsOfCondition(locale: $locale) {
    ...PageLoyaltyTermsOfCondition
    seoTags: _seoMetaTags {
      ...Seo
    }
  }
}
    ${PageLoyaltyTermsOfConditionFragmentDoc}
${SeoFragmentDoc}` as unknown as DocumentNode<LoyaltyTermsOfConditionQuery, LoyaltyTermsOfConditionQueryVariables>;
export const TicketOfferDocument = gql`
    query ticketOffer($locale: SiteLocale!, $eventId: ItemId!, $code: String!) {
  ticketOffer(locale: $locale, filter: {slug: {eq: $code}, event: {eq: $eventId}}) {
    id
    code: slug
    event {
      slug
    }
    customerLoyaltyId
    available
    categories {
      title
      ticketIds
    }
  }
}
    ` as unknown as DocumentNode<TicketOfferQuery, TicketOfferQueryVariables>;
export const AllPageSlugsDocument = gql`
    query allPageSlugs($locale: SiteLocale!) {
  allPages(locale: $locale, orderBy: _updatedAt_DESC) {
    slug
    title
    cover {
      ...ImageFile
    }
  }
}
    ${ImageFileFragmentDoc}` as unknown as DocumentNode<AllPageSlugsQuery, AllPageSlugsQueryVariables>;
export const PageDocument = gql`
    query page($locale: SiteLocale!, $filter: PageModelFilter, $currentISOString: DateTime) {
  page(locale: $locale, filter: $filter) {
    ...Page
    seoTags: _seoMetaTags {
      ...Seo
    }
  }
}
    ${PageFragmentDoc}
${ImageFileFragmentDoc}
${ContentBlockFragmentDoc}
${MediaBlockFragmentDoc}
${FaqFragmentDoc}
${FaqGroupFragmentDoc}
${FaqItemFragmentDoc}
${CountdownFragmentDoc}
${SplitImageContentBlockFragmentDoc}
${CtaFragmentDoc}
${CtaPageFieldFragmentDoc}
${SectionFragmentDoc}
${HeroBannerSectionFragmentDoc}
${FileFieldFragmentDoc}
${VideoUploadFileFragmentDoc}
${LineupSectionFragmentDoc}
${LineupSectionItemFragmentDoc}
${PerformerFragmentDoc}
${CardsSectionFragmentDoc}
${TicketCardFragmentDoc}
${IframeBlockFragmentDoc}
${FeaturedItemsBlockFragmentDoc}
${FeaturedItemFragmentDoc}
${EventCardFragmentDoc}
${XpProgramFragmentDoc}
${CollectionFragmentDoc}
${PageCardFragmentDoc}
${SeoFragmentDoc}` as unknown as DocumentNode<PageQuery, PageQueryVariables>;
export const TicketsEventIdByDatoEventSlugDocument = gql`
    query ticketsEventIdByDatoEventSlug($locale: SiteLocale!, $slug: String!) {
  pageEvent(locale: $locale, filter: {slug: {eq: $slug}}) {
    ticketsEventId
    ticketsTimeslotId
  }
}
    ` as unknown as DocumentNode<TicketsEventIdByDatoEventSlugQuery, TicketsEventIdByDatoEventSlugQueryVariables>;